(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('craft-reveal--visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;

  const counterObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.45 })
    : null;

  const animateCounter = (element) => {
    if (element.dataset.craftCounted === 'true') return;
    element.dataset.craftCounted = 'true';
    const target = Number.parseInt(element.dataset.craftCount || '0', 10);
    if (!Number.isFinite(target) || target < 0 || reducedMotion.matches) {
      element.textContent = String(target || 0);
      return;
    }
    const duration = 900;
    const start = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      element.textContent = String(Math.round(target * eased));
      if (progress < 1) window.requestAnimationFrame(tick);
    };
    window.requestAnimationFrame(tick);
  };

  const init = (scope = document) => {
    const mainSections = [...document.querySelectorAll('#MainContent > .shopify-section')];
    mainSections.slice(1).forEach((section) => {
      if (section.dataset.craftRevealReady === 'true') return;
      section.dataset.craftRevealReady = 'true';
      if (reducedMotion.matches || section.getBoundingClientRect().top <= window.innerHeight * 0.92) {
        section.classList.add('craft-reveal--visible');
        return;
      }
      section.classList.add('craft-reveal');
      revealObserver?.observe(section);
    });

    scope.querySelectorAll('[data-craft-count]').forEach((counter) => {
      if (counter.dataset.craftCounterReady === 'true') return;
      counter.dataset.craftCounterReady = 'true';
      if (counterObserver) counterObserver.observe(counter);
      else animateCounter(counter);
    });
  };

  let parallaxFrame;
  const updateParallax = () => {
    parallaxFrame = undefined;
    const heroContent = document.querySelector('.craft-campaign-hero__content');
    if (!heroContent || reducedMotion.matches || window.innerWidth < 990) return;
    const hero = heroContent.closest('.slideshow');
    if (!hero) return;
    const rect = hero.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;
    const progress = Math.max(-1, Math.min(1, -rect.top / Math.max(rect.height, 1)));
    heroContent.style.setProperty('--craft-parallax-y', `${Math.round(progress * 18)}px`);
  };

  const requestParallax = () => {
    if (parallaxFrame || reducedMotion.matches) return;
    parallaxFrame = window.requestAnimationFrame(updateParallax);
  };

  document.addEventListener('DOMContentLoaded', () => {
    init();
    updateParallax();
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('scroll', requestParallax, { passive: true });
  window.addEventListener('resize', requestParallax, { passive: true });
})();
